var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-standard",class:_vm.buttonStyle,attrs:{"disabled":_vm.disabled}},[_c('div',{staticClass:"state-layer"},[(_vm.buttonText)?_c('span',{staticClass:"label__large"},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }